export const catalog = "catalog";
export const core = "core";
export const admins = "admins";
export const members = "members";
export const sponsors = "sponsors";
